import { Table, Thead, Tbody, Tr, Th, Alert, AlertIcon, Box, useBreakpointValue } from '@chakra-ui/react'
import { ItemRow } from './ItemRow'

export function CollapseTable({ items, getStatusColor }) {
  const tableSize = useBreakpointValue({ base: 'sm', md: 'md' })

  if (!items || items.length === 0) {
    return (
      <Alert status="info" mt={2} borderRadius="md">
        <AlertIcon />
        Nenhum item encontrado para este pedido
      </Alert>
    )
  }

  return (
    <Box overflowX="auto" borderRadius="lg" bg="#3a4a53" p={2}>
      <Table variant="simple" size={tableSize} colorScheme="whiteAlpha">
        <Thead>
          <Tr>
            <Th color="#37F091">Seq.</Th>
            <Th color="#37F091">Código</Th>
            <Th color="#37F091">Descrição</Th>
            <Th color="#37F091">Qtd.</Th>
            <Th color="#37F091">Passo Atual</Th>
            <Th color="#37F091">Próximo Passo</Th>
          </Tr>
        </Thead>
        <Tbody>
          {items.map((item) => (
            <ItemRow key={item.sequencia} item={item} getStatusColor={getStatusColor} />
          ))}
        </Tbody>
      </Table>
    </Box>
  )
}
